import actions from './actions'
import mutations from './mutations'
import getters from './getters'

export default {
  namespaced: true,
  state() {
    return {
      screen_id: null
    }
  },
  getters,
  actions,
  mutations
}
